(function initializeAddToCartErrorHandler() {
    if (window.__addToCartValidationListener) return;
    window.__addToCartValidationListener = true;

    const LOCAL_STORAGE_KEY = 'validationNotifyTimestamps';
    const THROTTLE_INTERVAL_MS = 15 * 60 * 1000; // 15 minutes

    const normalizeErrorMessageToString = function (errorPayload) {
        try {
            if (!errorPayload) return '';
            if (Array.isArray(errorPayload)) return errorPayload.join('\n');
            if (typeof errorPayload === 'string') return errorPayload;
            if (typeof errorPayload === 'object') return JSON.stringify(errorPayload);
            return String(errorPayload);
        } catch {
            return '';
        }
    };

    const parseProductsFromCartErrorMessage = function (errorMessageString) {
        if (typeof errorMessageString !== 'string' || !errorMessageString.trim()) return [];

        const productMatchPattern = /([^,]+?)\s*\(ID:\s*([A-Z]+-\d+)\)/g;
        const deduplicatedProductsMap = {};
        let productMatchExecResult;
        while ((productMatchExecResult = productMatchPattern.exec(errorMessageString)) !== null) {
            const productKeyRawString = (productMatchExecResult[2] || '').trim();
            if (!productKeyRawString) continue;
            const hyphenIndex = productKeyRawString.indexOf('-');
            const validationKeyTypePrefix = hyphenIndex > 0 ? productKeyRawString.slice(0, hyphenIndex) : '';
            const validationProductIdString = hyphenIndex > 0 ? productKeyRawString.slice(hyphenIndex + 1) : productKeyRawString;
            if (!deduplicatedProductsMap[productKeyRawString]) {
                deduplicatedProductsMap[productKeyRawString] = { productKeyRaw: productKeyRawString, validationKeyType: validationKeyTypePrefix, validationProductId: validationProductIdString };
            }
        }
        return Object.values(deduplicatedProductsMap);
    };

    const loadNotifyTimestampsMap = function () {
        try {
            const raw = localStorage.getItem(LOCAL_STORAGE_KEY);
            if (!raw) return {};
            const parsed = JSON.parse(raw);
            if (!parsed || typeof parsed !== 'object') return {};
            return parsed;
        } catch {
            return {};
        }
    };

    const saveNotifyTimestampsMap = function (timestampsMap) {
        try {
            localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(timestampsMap || {}));
        } catch {
            // ignore storage errors
        }
    };

    const filterProductsAllowedToSend = function (products, timestampsMap, currentTimeMs) {
        if (!Array.isArray(products) || !products.length) return [];
        const allowed = [];
        const seenProductIds = Object.create(null);
        for (let i = 0; i < products.length; i++) {
            const product = products[i];
            const productIdKey = product && product.validationProductId ? String(product.validationProductId) : '';
            if (!productIdKey) continue;
            if (seenProductIds[productIdKey]) continue;
            seenProductIds[productIdKey] = true;

            const legacyCompositeKey = product && product.productKeyRaw ? String(product.productKeyRaw) : '';
            const lastSentAtFromId = Number(timestampsMap[productIdKey] || 0);
            const lastSentAtFromLegacy = Number(timestampsMap[legacyCompositeKey] || 0);
            const lastSentAtMs = Number.isFinite(lastSentAtFromId) && lastSentAtFromId > 0
                ? lastSentAtFromId
                : (Number.isFinite(lastSentAtFromLegacy) ? lastSentAtFromLegacy : 0);

            if (!Number.isFinite(lastSentAtMs) || currentTimeMs - lastSentAtMs >= THROTTLE_INTERVAL_MS) {
                allowed.push(product);
            }
        }
        return allowed;
    };

    const handleCartErrorEvent = function (cartErrorEvent) {
        try {
            const errorPayload = cartErrorEvent?.detail?.error ?? undefined;
            const errorMessageString = normalizeErrorMessageToString(errorPayload);
            const parsedProductsFromError = parseProductsFromCartErrorMessage(errorMessageString);
            if (!parsedProductsFromError.length) return;

            const nowMs = Date.now();
            const notifyTimestampsMap = loadNotifyTimestampsMap();
            const productsAllowedToSend = filterProductsAllowedToSend(parsedProductsFromError, notifyTimestampsMap, nowMs);
            if (!productsAllowedToSend.length) return; // nothing to send within 15 min window

            const requestBody = new URLSearchParams({
                payload: JSON.stringify(productsAllowedToSend),
            }).toString();

            fetch('/apps/rss-app/validation-notify', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'Accept': 'application/json',
                },
                body: requestBody,
                keepalive: true,
            })
                .then((response) => response.json().catch(() => null))
                .then((responseJson) => {
                    if (!responseJson || responseJson.status !== true) {
                        console.log('[Validation Notify] Failed', responseJson && (responseJson.errorMessage || responseJson));
                        return;
                    }
                    const updatedNowMs = Date.now();
                    for (let i = 0; i < productsAllowedToSend.length; i++) {
                        const product = productsAllowedToSend[i] || {};
                        const productIdKey = product && product.validationProductId ? String(product.validationProductId) : '';
                        const legacyCompositeKey = product && product.productKeyRaw ? String(product.productKeyRaw) : '';
                        if (!productIdKey) continue;

                        notifyTimestampsMap[productIdKey] = updatedNowMs;

                        if (legacyCompositeKey && legacyCompositeKey !== productIdKey && Object.prototype.hasOwnProperty.call(notifyTimestampsMap, legacyCompositeKey)) {
                            try { delete notifyTimestampsMap[legacyCompositeKey]; } catch {}
                        }
                    }
                    saveNotifyTimestampsMap(notifyTimestampsMap);
                })
                .catch((networkError) => {
                    console.log('[Validation Notify] Network error', networkError && networkError.message ? networkError.message : networkError);
                });
        } catch (unexpectedError) {
            // never break UI
        }
    };

    document.addEventListener('on:cart:error', handleCartErrorEvent);
})();